import React from 'react';
import { useSelectCurrentApp } from '@bbkAdminRedux/rtkq/current-user.slice';
import { cs, type Argument } from '@bbkAdminUtils/css-utils';
import { FeatureFlagsE, useFeatureFlags } from '@bbkAdminUtils/feature-flags';
import { useGetProductLicense } from '@bbkAdminUtils/plans';

export const DemoDataBanner: React.FC<
  React.PropsWithChildren<{ className?: Argument; isDemoData?: boolean }>
> = ({ className, children, isDemoData: isDemoDataProp }) => {
  const app = useSelectCurrentApp();
  const showDemoData = useFeatureFlags(FeatureFlagsE.ENABLE_DEMO_REPORTS);
  const isDemoData = isDemoDataProp ?? (app?.show_demo_data || showDemoData);
  const productLicense = useGetProductLicense();
  const growthV2License = productLicense?.growthV2License;

  return isDemoData ? (
    <div
      className={cs('-tw-mt-4 tw-mb-2 tw-flex tw-justify-center', className)}
    >
      <div
        className={cs(
          'tw-px-2 tw-py-0.5',
          'tw-border tw-border-cbrwarn-600',
          'tw-text-center tw-text-sm tw-text-cbrwarn-600',
          'tw-rounded tw-bg-cbrwarn-50'
        )}
      >
        {children ?? (
          <>
            {growthV2License
              ? 'Sample data shown here. Launch a play to view real data.'
              : 'Sample data shown here. Launch a live cancel page to view real data.'}
          </>
        )}
      </div>
    </div>
  ) : undefined;
};
